import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";

import { INSIGHTS_BACKEND_URL } from "@/lib/axios";
import { MutationConfig } from "@/lib/react-query";
import { axiosApi } from "@/Utils";

import { useScenarioBuilderClient } from "../../api/hooks/useScenarioBuilderClient";
import { deleteScenarioV2 } from "./v2/deleteScenario";

export const deleteScenario = (scenarioId: string): Promise<any> => {
  return axiosApi.delete(`/api/v2/scenarios-new/${scenarioId}`, {
    baseURL: INSIGHTS_BACKEND_URL,
  });
};

type UseDeleteScenarioOptions = {
  isScenariosApiEnabled?: boolean;
  config?: MutationConfig<typeof deleteScenario>;
};

export const useDeleteScenario = ({
  isScenariosApiEnabled,
  config,
}: UseDeleteScenarioOptions = {}) => {
  const queryClient = useQueryClient();
  const scenarioBuilderClient = useScenarioBuilderClient();

  return useMutation({
    onSuccess: async () => {
      if (isScenariosApiEnabled) {
        await queryClient.invalidateQueries({ queryKey: ["scenarios-v2"] });
      } else {
        await queryClient.invalidateQueries({ queryKey: ["scenarios-new"] });
        await queryClient.invalidateQueries({ queryKey: ["is-optimizer-running"] });
      }
      toast.success(`Scenario successfully deleted`);
    },
    onError: (data) => {
      console.log(data);
      toast.error(`Scenario failed to delete. Please try again.`);
    },
    ...config,
    mutationFn: isScenariosApiEnabled
      ? (scenarioId: string) => deleteScenarioV2(scenarioBuilderClient, scenarioId)
      : deleteScenario,
  });
};
